

















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import CentroDeCustoStore from '@/components/RemuneracaoMedica/financeiro/Store/CentroDeCustoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ModalCriarEditarCentroDeCusto extends Vue {
  @Prop({ default: 'CREATE' }) mode!: string

  formValido: boolean = true
  salvando: boolean = false

  get store() {
    return getModule(CentroDeCustoStore, this.$store)
  }

  get show() {
    return this.store.modalCriarEditar
  }

  set show(value: boolean) {
    this.store.setModalCriarEditar(value)
  }

  async salvar() {
    const form = this.$refs.form as any
    if (form && !form.validate()) return

    this.salvando = true
    const response: any = await this.store.salvar()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Centro de custo salvo com sucesso!', icon: 'done', color: '#2E7D32' })
      this.show = false
      this.$emit('update-items-table')
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao salvar.', icon: 'warning', color: '#C62828' })
    }
    this.salvando = false
  }
}
